 
import E from 'wangeditor'
import 'wangeditor/release/wangEditor.min.css'

export default{ 
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'信息列表', path:''
            },{
                name:'信息详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/info/save',//保存
                bykey:'oa/official/info/byKey',//详情
                fileNumList:'oa/fn/cfg/list', //文号配置列表
                getFileNum:'oa/fn/cfg/getFileNum',
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editor:null,//编辑器
            editObj:{
                title:"",  
                isRelease:0,
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"", 
            fileNumList:[], 
            WFtask:{}, 
            setting: {   
                language: 'zh_CN', //本地化设置
                height: 500,  
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bizKey: String,
    }, 
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                             
    methods: { 
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj; 
                }
            })
        },  
        goBack(){ 
            this.$router.go(-1);
        },   
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/info/view/view.js